function e(e) {
  return e && "object" == typeof e && "default" in e ? e.default : e;
}
var t = e(require("axios")),
  i = e(require("nprogress")),
  n = {
    modal: null,
    listener: null,
    show: function (e) {
      var t = this,
        i = document.createElement("html");
      i.innerHTML = e, i.querySelectorAll("a").forEach(function (e) {
        return e.setAttribute("target", "_top");
      }), this.modal = document.createElement("div"), this.modal.style.position = "fixed", this.modal.style.width = "100vw", this.modal.style.height = "100vh", this.modal.style.padding = "50px", this.modal.style.boxSizing = "border-box", this.modal.style.backgroundColor = "rgba(0, 0, 0, .6)", this.modal.style.zIndex = 2e5, this.modal.addEventListener("click", function () {
        return t.hide();
      });
      var n = document.createElement("iframe");
      n.style.backgroundColor = "white", n.style.borderRadius = "5px", n.style.width = "100%", n.style.height = "100%", this.modal.appendChild(n), document.body.prepend(this.modal), document.body.style.overflow = "hidden", n.contentWindow.document.open(), n.contentWindow.document.write(i.outerHTML), n.contentWindow.document.close(), this.listener = this.hideOnEscape.bind(this), document.addEventListener("keydown", this.listener);
    },
    hide: function () {
      this.modal.outerHTML = "", this.modal = null, document.body.style.overflow = "visible", document.removeEventListener("keydown", this.listener);
    },
    hideOnEscape: function (e) {
      27 === e.keyCode && this.hide();
    }
  };
i.configure({
  showSpinner: !1
});
var o = {
  delay: null,
  loading: !1,
  start: function () {
    var e = this;
    clearTimeout(this.delay), this.delay = setTimeout(function () {
      e.loading = !0, i.set(0), i.start();
    }, 250);
  },
  increment: function () {
    this.loading && i.inc(.4);
  },
  stop: function () {
    clearTimeout(this.delay), this.loading && (i.done(), this.loading = !1);
  }
};
exports.Inertia = {
  resolveComponent: null,
  updatePage: null,
  version: null,
  visitId: null,
  cancelToken: null,
  page: null,
  init: function (e) {
    var t = e.initialPage,
      i = e.updatePage;
    this.resolveComponent = e.resolveComponent, this.updatePage = i, window.history.state && "back_forward" === this.navigationType() ? this.setPage(window.history.state) : window.sessionStorage.getItem("inertia.hardVisit") ? (window.sessionStorage.removeItem("inertia.hardVisit"), this.setPage(t, {
      preserveState: !0
    })) : (t.url += window.location.hash, this.setPage(t)), window.addEventListener("popstate", this.restoreState.bind(this));
  },
  navigationType: function () {
    if (window.performance && window.performance.getEntriesByType("navigation").length) return window.performance.getEntriesByType("navigation")[0].type;
  },
  isInertiaResponse: function (e) {
    return e && e.headers["x-inertia"];
  },
  cancelActiveVisits: function () {
    this.cancelToken && this.cancelToken.cancel(this.cancelToken), this.cancelToken = t.CancelToken.source();
  },
  createVisitId: function () {
    return this.visitId = {}, this.visitId;
  },
  visit: function (e, i) {
    var s = this;
    void 0 === i && (i = {});
    var r = i.method;
    void 0 === r && (r = "get");
    var a = i.data;
    void 0 === a && (a = {});
    var d = i.replace;
    void 0 === d && (d = !1);
    var c = i.preserveScroll;
    void 0 === c && (c = !1);
    var l = i.preserveState;
    void 0 === l && (l = !1);
    var h = i.only;
    void 0 === h && (h = []), o.start(), this.cancelActiveVisits();
    var u = this.createVisitId();
    return t({
      method: r,
      url: e.toString(),
      data: "get" === r.toLowerCase() ? {} : a,
      params: "get" === r.toLowerCase() ? a : {},
      cancelToken: this.cancelToken.token,
      headers: Object.assign({}, {
        Accept: "text/html, application/xhtml+xml",
        "X-Requested-With": "XMLHttpRequest",
        "X-Inertia": !0
      }, h.length ? {
        "X-Inertia-Partial-Component": this.page.component,
        "X-Inertia-Partial-Data": h.join(",")
      } : {}, this.version ? {
        "X-Inertia-Version": this.version
      } : {})
    }).then(function (e) {
      if (s.isInertiaResponse(e)) return e.data;
      n.show(e.data);
    }).catch(function (e) {
      if (!t.isCancel(e)) return 409 === e.response.status && e.response.headers["x-inertia-location"] ? (o.stop(), s.hardVisit(!0, e.response.headers["x-inertia-location"])) : s.isInertiaResponse(e.response) ? e.response.data : e.response ? (o.stop(), void n.show(e.response.data)) : Promise.reject(e);
    }).then(function (e) {
      if (e) return h.length && (e.props = Object.assign({}, s.page.props, e.props)), s.setPage(e, {
        visitId: u,
        replace: d,
        preserveScroll: c,
        preserveState: l
      });
    });
  },
  hardVisit: function (e, t) {
    window.sessionStorage.setItem("inertia.hardVisit", !0), e ? window.location.replace(t) : window.location.href = t;
  },
  setPage: function (e, t) {
    var i = this;
    void 0 === t && (t = {});
    var n = t.visitId;
    void 0 === n && (n = this.createVisitId());
    var s = t.replace;
    void 0 === s && (s = !1);
    var r = t.preserveScroll;
    void 0 === r && (r = !1);
    var a = t.preserveState;
    return void 0 === a && (a = !1), this.page = e, o.increment(), Promise.resolve(this.resolveComponent(e.component)).then(function (t) {
      n === i.visitId && (a = "function" == typeof a ? a(e.props) : a, r = "function" == typeof r ? r(e.props) : r, i.version = e.version, i.setState(e, s, a), i.updatePage(t, e.props, {
        preserveState: a
      }), i.setScroll(r), o.stop());
    });
  },
  setScroll: function (e) {
    e || document.querySelectorAll("html,body,[scroll-region]").forEach(function (e) {
      return e.scrollTo(0, 0);
    });
  },
  setState: function (e, t, i) {
    void 0 === t && (t = !1), void 0 === i && (i = !1), t || e.url === "" + window.location.pathname + window.location.search ? window.history.replaceState(Object.assign({}, {
      cache: i && window.history.state ? window.history.state.cache : {}
    }, e), "", e.url) : window.history.pushState(Object.assign({}, {
      cache: {}
    }, e), "", e.url);
  },
  restoreState: function (e) {
    e.state && this.setPage(e.state);
  },
  replace: function (e, t) {
    return void 0 === t && (t = {}), this.visit(e, Object.assign({}, {
      preserveState: !0
    }, t, {
      replace: !0
    }));
  },
  reload: function (e) {
    return void 0 === e && (e = {}), this.replace(window.location.href, e);
  },
  post: function (e, t, i) {
    return void 0 === t && (t = {}), void 0 === i && (i = {}), this.visit(e, Object.assign({}, {
      preserveState: !0
    }, i, {
      method: "post",
      data: t
    }));
  },
  put: function (e, t, i) {
    return void 0 === t && (t = {}), void 0 === i && (i = {}), this.visit(e, Object.assign({}, {
      preserveState: !0
    }, i, {
      method: "put",
      data: t
    }));
  },
  patch: function (e, t, i) {
    return void 0 === t && (t = {}), void 0 === i && (i = {}), this.visit(e, Object.assign({}, {
      preserveState: !0
    }, i, {
      method: "patch",
      data: t
    }));
  },
  delete: function (e, t) {
    return void 0 === t && (t = {}), this.visit(e, Object.assign({}, t, {
      method: "delete"
    }));
  },
  remember: function (e, t) {
    void 0 === t && (t = "default");
    var i = Object.assign({}, window.history.state);
    i.cache = i.cache || {}, i.cache[t] = e, this.setState(i);
  },
  restore: function (e) {
    if (void 0 === e && (e = "default"), window.history.state.cache && window.history.state.cache[e]) return window.history.state.cache[e];
  }
}, exports.shouldIntercept = function (e) {
  return !(e.target && e.target.isContentEditable || e.defaultPrevented || e.which > 1 || e.altKey || e.ctrlKey || e.metaKey || e.shiftKey);
};